export default {
    EXAMPLE: 'EXAMPLE',
    CURRENT_MODEL_INFO: 'CURRENT_MODEL_INFO', // 当前显示页的模板id
    MODELS_INFO: 'MODELS_INFO', // 所有频道及数据
    WEB_MODELS: 'WEB_MODELS', // 网站拥有的模板
    CUR_SPECIAL: 'CUR_SPECIAL', // 当前进入的专题
    WEB_ID:'WEB_ID',//根据域名获取webid参数
    HIDE_FOOTER:'HIDE_FOOTER',//ctnews域名隐藏底部
    ACTIVE_CHANEL_INDEX:"ACTIVE_CHANEL_INDEX",//当前切换的频道
    LOGO_SRC:'LOGO_SRC',
    LOGIN_SUCCESS:'LOGIN_SUCCESS',
    SORT:"SORT",
    STRUCT:"STRUCT",
    STARTTIME:"STARTTIME",
    ENDTIME:"ENDTIME",
    IS_GAONS:"IS_GAONS",
    IS_ENGLISH:"IS_ENGLISH",
    setArea_mutations:'setArea_mutations',
    setCountry_mutations:'setCountry_mutations',
    setCity_mutations:'setCity_mutations',
}


// WEBPACK FOOTER //
// ./src/store/types.js